import { fetchExtensionLocationSuggestions, LocationSuggestionsResult } from 'lib/extensionMessaging';

export const INDEED_LOCATION_TYPEAHEAD_MESSAGE = 'harbor-indeed-location-typeahead';

export type IndeedLocationSuggestionsResult = LocationSuggestionsResult;

export function fetchIndeedLocationSuggestions(query: string): Promise<IndeedLocationSuggestionsResult> {
  return fetchExtensionLocationSuggestions(INDEED_LOCATION_TYPEAHEAD_MESSAGE, { query });
}
